import type { DocumentAppliedFromFactoringQuote } from 'lib/api/conciliations/types';

export const payersHeaders = [
  { key: 'stakeholderName', label: 'Pagador' },
  { key: 'stakeholderIdentifier', label: 'Rut' },
  { key: 'documentsCount', label: 'Documentos' },
  { key: 'totalAmount', label: 'Monto', type: 'money' },
  {
    key: 'concentrationLimit',
    label: 'Límite de Concentración',
    type: 'money',
  },
  {
    key: 'amountArrear',
    label: 'Mora',
    type: 'money',
  },
  {
    key: 'conciliatedByBusinessAmount',
    label: 'Recaudado cliente',
    type: 'money',
  },
  {
    key: 'conciliatedByStakeholderAmount',
    label: 'Recaudado pagador',
    type: 'money',
  },
  {
    key: 'conciliatedTotalAmount',
    label: 'Recaudado total',
    type: 'money',
  },
];
export const documentssHeaders = [
  {
    key: 'folio',
    label: 'Folio',
  },
  {
    key: 'code',
    label: 'Código Doc.',
  },
  {
    key: 'stakeholderName',
    label: 'Pagador',
  },
  { key: 'stakeholderIdentifier', label: 'Rut pagador' },
  { key: 'stakeholderSegment', label: 'Segmento pagador' },

  {
    key: 'paymentDate',
    label: 'Fecha pago',
    type: 'date',
  },
  {
    key: 'confirmStatus',
    label: 'Verificación',
    type: 'verificationStatus',
    canNull: true,
  },
  {
    key: 'confirmedBy',
    label: 'Verificado por',
    canNull: true,
  },
  {
    key: 'confirmType',
    label: 'Tipo Verificación',
    canNull: true,
  },
  {
    key: 'confirmMessage',
    label: 'Comentario',
  },
  {
    key: 'cancelDate',
    label: 'Reclamos?',
    type: 'cession-lights-false',
    canNull: true,
  },
  {
    key: 'invoiceAmount',
    label: 'Monto original',
    type: 'money',
  },
  {
    key: 'amountDocument',
    label: 'Monto',
    type: 'money',
  },
  {
    key: 'amountFinanced',
    label: 'Monto financiado',
    type: 'money',
  },

  {
    key: 'costRate',
    label: 'Costo tasa',
    type: 'money',
  },
  {
    key: 'amountToDeposit',
    label: 'Montos a depositar',
    type: 'money',
  },
];

const appliedHeadersBase = [
  { key: 'folio', label: 'Folio' },
  { key: 'type', label: 'Tipo de doc.' },
  { key: 'requestType', label: 'Tipo de solicitud' },
  { key: 'requestId', label: 'Solicitud' },
  {
    key: 'stakeholderName',
    label: 'Pagador',
  },
  {
    key: 'amount',
    label: 'Monto',
    type: 'money',
  },
  {
    key: 'amountConciliated',
    label: 'Monto aplicado',
    type: 'money',
  },
];

const appliedHeadersOptional = [
  { key: 'categoryName', label: 'Categoría', type: 'text' as const },
  { key: 'observation', label: 'Observación', type: 'text' as const },
];

export function getAppliedHeaders(
  documents: DocumentAppliedFromFactoringQuote[] | undefined | null,
): typeof appliedHeadersBase {
  const list = documents ?? [];
  const hasCategoryName = list.some((doc) => (doc?.categoryName ?? '') !== '');
  const hasObservation = list.some((doc) => (doc?.observation ?? '') !== '');
  const optional = appliedHeadersOptional.filter(
    (h) =>
      (h.key === 'categoryName' && hasCategoryName) ||
      (h.key === 'observation' && hasObservation),
  );
  return [...appliedHeadersBase, ...optional];
}

export const appliedHeaders = appliedHeadersBase;
